import { render, staticRenderFns } from "./InvoicePage.vue?vue&type=template&id=4551e594&scoped=true&"
import script from "./InvoicePage.vue?vue&type=script&lang=js&"
export * from "./InvoicePage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePage.vue?vue&type=style&index=0&id=4551e594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551e594",
  null
  
)

export default component.exports